/**
 * Clickable table header for master-data pages. Pair with `useTableSort` hook.
 *
 * <SortableTh
 *   label="Name"
 *   colKey="name"
 *   activeKey={sortKey}
 *   direction={sortDir}
 *   onToggle={toggle}
 *   align="left"   // or "right" for numeric columns
 * />
 */
export function SortableTh({
  label,
  colKey,
  activeKey,
  direction,
  onToggle,
  align = "left",
}) {
  const active = activeKey === colKey;
  const arrow = active ? (direction === "asc" ? "▲" : "▼") : "↕";
  const alignClass = align === "right" ? "text-right" : "text-left";
  return (
    <th
      className={`${alignClass} px-4 py-3 cursor-pointer select-none hover:bg-slate-100 transition-colors`}
      onClick={() => onToggle(colKey)}
      data-testid={`sort-${colKey}`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        <span
          className={`text-[10px] ${active ? "text-slate-700" : "text-slate-300"}`}
        >
          {arrow}
        </span>
      </span>
    </th>
  );
}
